export default __webpack_public_path__ + "static/media/not-found-404.edcdd101.jpg";